import {combineReducers} from '@reduxjs/toolkit';
import portfolioReducer from '../mobile/state/portfolio-reducer.js';
import applicationReducer from './reducer.js';

const rootReducer = combineReducers({
  application: applicationReducer,
  portfolio: portfolioReducer,
});

export default rootReducer;
